import React from 'react';
import './TermsOfService.css';

function TermsOfService() {
  // Get current year for copyright notice
  const currentYear = new Date().getFullYear();

  return (
    <div className="page-container terms-page">
      {/* Hero Banner Section */}
      <section className="terms-hero-banner">
        <div className="hero-overlay"></div>
        <div className="container">
          <h1>Terms of Service</h1>
          <p className="last-updated">Last Updated: March 15, {currentYear}</p>
        </div>
      </section>

      {/* Main Content Section */}
      <section className="terms-content">
        <div className="container">
          <div className="terms-section">
            <h2>Introduction</h2>
            <p>
              Welcome to rkube. These Terms of Service ("Terms") govern your use of our website, products, 
              and services ("Services"). By accessing or using our Services, you agree to be bound by 
              these Terms. If you disagree with any part of the Terms, you may not access the Services.
            </p>
          </div>

          <div className="terms-section">
            <h2>Use of Services</h2>
            <p>
              Our Services are intended for businesses and professionals seeking financial management, 
              tax, compliance, and related services. By using our Services, you represent and warrant that:
            </p>
            <ol>
              <li>You have the legal authority to enter into a binding agreement;</li>
              <li>You will use the Services in accordance with these Terms;</li>
              <li>The information you provide is accurate and complete;</li>
              <li>Your use of the Services does not violate any applicable law or regulation.</li>
            </ol>
          </div>

          <div className="terms-section">
            <h2>Account Registration</h2>
            <p>
              When you create an account with us, you must provide accurate, complete, and current 
              information. Failure to do so constitutes a breach of the Terms, which may result in 
              immediate termination of your account.
            </p>
            <p>
              You are responsible for safeguarding the password you use to access the Services and for 
              any activities or actions under your password. We encourage you to use "strong" passwords 
              (passwords that use a combination of upper and lower case letters, numbers, and symbols) 
              with your account.
            </p>
          </div>

          <div className="terms-section">
            <h2>Service Fees and Payment</h2>
            <p>
              You agree to pay the fees for the Services you purchase or subscribe to. 
              All fees are exclusive of all taxes, levies, or duties imposed by taxing authorities, 
              and you will be responsible for payment of all such taxes, levies, or duties.
            </p>
            <p>
              We may change our fees at any time. If you don't agree with the fee changes, you must 
              stop using the Services and cancel your subscription.
            </p>
          </div>

          <div className="terms-section">
            <h2>Intellectual Property</h2>
            <p>
              The Services and all materials therein, including, without limitation, software, images, 
              text, graphics, illustrations, logos, patents, trademarks, service marks, copyrights, 
              photographs, audio, videos, and music (the "Content"), and all intellectual property 
              rights related thereto, are the exclusive property of rkube and our licensors.
            </p>
            <p>
              Except as explicitly provided herein, nothing in these Terms shall be deemed to create a 
              license in or under any such intellectual property rights, and you agree not to sell, 
              license, rent, modify, distribute, copy, reproduce, transmit, publicly display, publicly 
              perform, publish, adapt, edit, or create derivative works from any materials or Content 
              accessible on the Services.
            </p>
          </div>

          <div className="terms-section">
            <h2>User Content</h2>
            <p>
              Our Services may allow you to post, link, store, share, and otherwise make available certain 
              information, text, graphics, videos, or other material ("User Content"). You are responsible 
              for the User Content that you post on or through the Services, including its legality, 
              reliability, and appropriateness.
            </p>
            <p>
              By posting User Content on or through the Services, you represent and warrant that:
            </p>
            <ol>
              <li>The User Content is yours or you have the right to use it;</li>
              <li>The User Content does not violate the privacy rights, publicity rights, copyrights, contract rights, or any other rights of any person or entity;</li>
              <li>The User Content does not contain any material that could be considered defamatory, obscene, threatening, harassing, abusive, or hateful.</li>
            </ol>
          </div>

          <div className="terms-section">
            <h2>Limitation of Liability</h2>
            <p>
              In no event shall rkube, nor its directors, employees, partners, agents, suppliers, or 
              affiliates, be liable for any indirect, incidental, special, consequential, or punitive 
              damages, including without limitation, loss of profits, data, use, goodwill, or other 
              intangible losses, resulting from:
            </p>
            <ol>
              <li>Your access to or use of or inability to access or use the Services;</li>
              <li>Any conduct or content of any third party on the Services;</li>
              <li>Any content obtained from the Services; and</li>
              <li>Unauthorized access, use, or alteration of your transmissions or content, whether based on warranty, contract, tort (including negligence), or any other legal theory, whether or not we have been informed of the possibility of such damage.</li>
            </ol>
          </div>

          <div className="terms-section">
            <h2>Disclaimer</h2>
            <p>
              Your use of the Services is at your sole risk. The Services are provided on an "AS IS" and 
              "AS AVAILABLE" basis. The Services are provided without warranties of any kind, whether 
              express or implied, including, but not limited to, implied warranties of merchantability, 
              fitness for a particular purpose, non-infringement, or course of performance.
            </p>
          </div>

          <div className="terms-section">
            <h2>Governing Law</h2>
            <p>
              These Terms shall be governed and construed in accordance with the laws of North Carolina, 
              United States, without regard to its conflict of law provisions.
            </p>
            <p>
              Our failure to enforce any right or provision of these Terms will not be considered a 
              waiver of those rights. If any provision of these Terms is held to be invalid or 
              unenforceable by a court, the remaining provisions of these Terms will remain in effect.
            </p>
          </div>

          <div className="terms-section">
            <h2>Changes to Terms</h2>
            <p>
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. 
              If a revision is material, we will try to provide at least 30 days' notice prior to any 
              new terms taking effect. What constitutes a material change will be determined at our 
              sole discretion.
            </p>
            <p>
              By continuing to access or use our Services after those revisions become effective, 
              you agree to be bound by the revised terms. If you do not agree to the new terms, 
              please stop using the Services.
            </p>
          </div>

          <div className="terms-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about these Terms, please contact us:
            </p>
            <ul className="contact-list">
              <li>By email: support@rkubeservices.com</li>
              <li>By phone: +1 888-735-5515</li>
              <li>
                By mail: 4030 Wake Forest Rd, Raleigh, North Carolina
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}

export default TermsOfService; 